<!--
    @file:登录页面
-->
<template>
  <div id="login">
    <div class="logo">
        <div class="dsd-logo"></div>
        <div class="cn-logo"></div>
        <p class="en-logo">EV Batteries Remote Monitoring System</p>
    </div>
    <el-card class="card" :body-style="{ padding: '0px' }">
        <p class="login-label">登录</p>
        <el-form :model="ruleFormLogin" :rules="rulesLogin" ref="ruleFormLogin" class="login-ruleForm">
            <el-form-item  prop="username" class="username">
                <el-input  v-model="ruleFormLogin.username" placeholder="用户名" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item  prop="password" class="password">
                <el-input type="password" v-model="ruleFormLogin.password" placeholder="密码" auto-complete="off" > </el-input>
            </el-form-item>
            <el-form-item >
                <el-checkbox v-model="checkedRemember" class="remember" style="">记住密码</el-checkbox>
                <router-link to="404" class="forget"> 忘记密码 </router-link>
            </el-form-item>
            <v-drag v-on:drag="setBtActive" v-bind:initialDrag="initialDrag"></v-drag>
            <el-form-item>
               <el-button type="primary" @click="submitForm('ruleFormLogin')" :loading="logining" class="bt-login" :disabled="loginActive">登录</el-button>
            </el-form-item>
        </el-form>
    </el-card>
  </div>
</template>

<script>
import drag from './plugins/drag';
export default {
    name: 'login',
    created () {
        // 用户是否记住密码
        if (localStorage.getItem('USERNAME')) {
            this.ruleFormLogin.username = localStorage.getItem('USERNAME');
            this.ruleFormLogin.password = localStorage.getItem('PASSWORD');
        }
    },
    data () {
        // 验证是否输入用户名
        var validateusername = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入用户名'));
            } else {
                callback();
            }
        };
        // 验证是否输入密码
        var validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('请输入密码'));
            } else if (this.erroPass) {
                callback(new Error(this.erroMsm));
            } else {
                callback();
            }
        };
        return {
            logining: false, // 登录loading
            checkedRemember: true, // 是否记住密码
            loginActive: true, // 是否可点击登录
            erroPass: false, // 用与记录登录失败的情况,显示
            initialDrag: false, // 是否初始化滑动块
            erroMsm: '用户名或密码错误',
            ruleFormLogin: {
                username: '',
                password: ''
            },
            rulesLogin: {
                username: [
                    { validator: validateusername, trigger: 'blur' }
                ],
                password: [
                    { validator: validatePass, trigger: 'blur' }
                ]
            }
        };
    },
    components: {
        'v-drag': drag
    },
    methods: {
        submitForm (formName) {
            /**
             * 提交登录表单
             *
             * @param {string} formName 表单的名称
             *
             */
            localStorage.setItem('ACCESSTOKEN', 'res.data.jwt');
            this.$router.push({ path: '/main' });
            var self = this;
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    self.logining = true;
                    this.$ajax.get(self.Api.login, {
                        auth: self.ruleFormLogin
                    })
                    .then(function (res) {
                        if (res.status === 200) {
                            // 登录成功,存储认证/用户名/密码
                            localStorage.setItem('ACCESSTOKEN', res.data.jwt);
                            self.$ajax.defaults.headers.common['Authorization'] = res.data.jwt;
                            if (self.checkedRemember) {
                                localStorage.setItem('USERNAME', self.ruleFormLogin.username);
                                localStorage.setItem('PASSWORD', self.ruleFormLogin.password);
                            } else {
                                localStorage.removeItem('USERNAME');
                                localStorage.removeItem('PASSWORD');
                            }
                            self.$router.push({ path: '/main' });
                        } else {
                            self.submitErro(formName);
                        }
                    })
                    .catch(function (err) {
                        if (err.response && err.response.status === 401) {
                            self.erroMsm = '用户名或密码错误';
                        } else {
                            self.erroMsm = '服务器无应答';
                        }
                        self.AuthErro(formName);
                    });
                } else {
                    return false;
                }
            });
        },
        setBtActive () {
            this.loginActive = false;
        },
        AuthErro (formName) {
            /**
             * 登录失败,重置表单验证
             *
             * @param {string} formName 表单的名称
             *
             */
            this.erroPass = true;
            this.logining = false;
            this.$refs[formName].validate();
            this.erroPass = false;
            this.loginActive = true;
            this.initialDrag = !this.initialDrag;
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#login{
    width: 100%;
    height: 100%;
    background-image:
        url(../assets/img/login-top.png),
        url(../assets/img/login-top-left.png),
        url(../assets/img/login-bottom.png),
        -webkit-gradient(linear, left top, left bottom, color-stop(0%,#f7f8fa), color-stop(90%,#e3e8f2));
    background-repeat: no-repeat;
    background-position: top center,top left, bottom center,center;
    background-size: 100% auto;
    position: absolute;
}
.logo{
    padding:15px 0;
}
.dsd-logo{
    height: 50px;
    width: 300px;
    background-image:url(../assets/img/logo.png);
    background-repeat: no-repeat;
    background-position: left center;
    background-size: contain;
    position: absolute;
    top: 18px;
    left: 30px;
}
.cn-logo{
    background-image:url(../assets/img/top-logo.png);
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    height: 30px;
    margin: 0 0 5px 0;
}
.en-logo{
    font-size: 20px;
    color:#000;
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    margin: 0;
}
.forget{
    float: right;
    color: #5182e4;
    font-size: 12px;
}
#login .remember{
    float: left;
    font-size: 12px !important;
    color:#5182e4;
}
.card{
    width: 396px;
    height: 456px;
    position: absolute;
    right: 15%;
    top:50%;
    margin-top: -255px;
    box-shadow: none;
    border:none;
    background-color: rgba(255,255,255,0);
    background-image:url(../assets/img/loggin-panel.png);
    background-repeat: no-repeat;
    background-position:center;
    background-size: contain;
    padding:58px 93px 0 60px;
    box-sizing: border-box;
}
.login-label{
    color: #5182e4;
    margin: 27px 0;
    position: relative;
}
.login-label:after{
    content: '';
    width: 90px;
    height: 1px;
    background-color: #e5e5e5;
    position: absolute;
    right: 0;
    top: 13px;
}
.login-label:before{
    content: '';
    width: 90px;
    height: 1px;
    background-color: #e5e5e5;
    position: absolute;
    left: 0;
    top: 13px;
}
.bt-login{
    width: 100%;
    height: 27px;
    padding: 0;
    background-color: #5e82e4;
    border-color: #5e82e4;
    border-radius: 2px;
}
.bt-login.is-disabled, .bt-login.is-disabled:focus, .bt-login.is-disabled:hover{
    color:#999;
    background-color: #e5e5e5;
    border-color: #e5e5e5;
}
.login-ruleForm{

}
.el-input{
    height: 21px;
}
.el-form-item{
    background-repeat: no-repeat;
    background-position: left bottom;
    margin-bottom: 22px;
}
.username{
    background-image:url(../assets/img/username.png);
    margin-bottom: 22px;
}
.password{
    background-image:url(../assets/img/password.png);
    margin-bottom: 26px;
}
</style>
<style>
#login input{
    width: 210px;
    margin-left:30px;
    border-radius: 0;
    border-top:none;
    border-left: none;
    border-right: none;
    border-bottom: 1px solid #5182e4;
    outline: none;
    padding:0 6px;
    height: 21px;
    line-height: 21px;
}
#login input::-webkit-input-placeholder{
    font-size: 12px;
    color:#ccc;
}
#login input:-moz-placeholder{
    font-size: 12px;
    color:#ccc;
}
#login input::-moz-placeholder{
    font-size: 12px;
    color:#ccc;
}
#login input:-ms-input-placeholder{
    font-size: 12px;
    color:#ccc;
}
#login .el-form-item__error{
    left: auto;
    right: 0;
}
#login .el-form-item__content{
    line-height: 21px;
}
#login .el-checkbox__inner{
    border-radius: 0;
    width: 14px;
    height: 14px;
    border-color: #5182e4;
}
#login .el-checkbox__inner::after{
    border: 1px solid #5182e4;
    border-left: 0;
    border-top: 0;
    top: 0;
    left: 4px;
}
#login .el-checkbox__input.is-checked .el-checkbox__inner{
    background-color: #fff;
}
#login .el-checkbox__label{
    font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// login.vue?436a0ec6